import { Helmet } from "react-helmet"

function Kriteriji() {
    return (
        <div className="flex-container full-width flex-grow-1">
            <Helmet>
                <title>Historiografija.ba | Kriteriji</title>
                <meta
                    name="description"
                    content="Kriteriji za objavljivanje članaka"
                    data-react-helmet="true" 
                />
            </Helmet>
            <div className="full-width padding-2p static-page-container">
                <h1 className="font-weight-500">Kriteriji za recenzije</h1>
                <h2 className="font-weight-400">Sadržajni kriteriji</h2>
                <p>
                    Recenzija treba pružiti informacije o strukturi i sadržaju rada sa posebnim naglaskom na specifična pitanja i ponuđenu argumentaciju. Kod recenzije zbornika treba izbjeći osvrt na svaki rad pojedinačno tj. puko nabrajanje i svođenje teksta na sadržaj, već se očekuje da autor izvrši klasifikaciju publiciranih radova i da ih postavi u odgovarajući istraživački kontekst.Potrebno je istaći prednosti, ali i nedostatke, diskutiranog djela. Očekuje se da se pri tome kritične opservacije jasno i  nepolemičnim tonom izlože.  Recenzija treba završiti sažetom ocjenom rada.
                </p>
                <h2 className="font-weight-400">Formalni kriteriji</h2>
                <p>
                    Očekuje se da recenzija sadrži između 5.000 i 7.500 znakova. Redakcija zadržava pravo da po vlastitoj procjeni izvrši skraćivanja, a u krajnjem slučaju da potpuno odbaci dostavljeni tekst.Preporučuje se da se autori izražavaju u kraćim rečenicama i pasusima.
                </p>
                <br />

                <h1 className="font-weight-500">Kriteriji za radove</h1>
                <h2 className="font-weight-400">Sadržajni kriteriji</h2>
                <p>
                    Radovi trebaju ponuditi jasne teze i ključnu argumentaciju, a zadržavanje na poznatim stvarima treba biti vrlo kratko i služiti samo kao polazište u razradi vlastite teze. U izboru argumenata treba se opredijeliti za one koji na najbolji način potvrđuju osnovne teze rada.
                </p>
                <h2 className="font-weight-400">Struktura rada</h2>
                <p>
                    Nakon abstrakta i ključnih riječi potrebno je definirati temu i ukratko obrazložiti dosadašnji stupanj saznanja o tome, te ukazati na nedostatke dosadašnje literature. U prvom dijelu rada treba iznijeti osnovne teze koje autor zastupa. U drugom dijelu ponuditi glavne argumente i na kraju jasno sumirati rezultate.
                    <br />
                    Na kraju rada treba navesti sve izvore i literaturu spomenute u radu.
                </p>
                <h2 className="font-weight-400">Formalni kriteriji</h2>
                <p>
                    Očekuje se da radovi sadrže između 20.000 i 30.000 znakova. Svi radovi će biti anonimno recenzirani, a bit će objavljeni oni za koje Redakcija dobije dvije pozitivne recenzije.
                </p>
            </div>
        </div>
    )
}

export default Kriteriji
